import {StyleSheet} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.overlay,
      justifyContent: 'flex-end',
    },
    safeareaContainer: {
      backgroundColor: colors.surface,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      maxHeight: '90%',
    },
    bottomContainer: {
      padding: 24,
    },
    selectedChecBoxTitle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 18,
      color: colors.textPrimary,
    },
    normalChecBoxTitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 18,
      color: colors.textMuted,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 32,
    },
    button: {
      flex: 1,
    },
    ml16: {
      marginLeft: 16,
    },
    webContainer: {
      backgroundColor: colors.overlayLight,
      ...CommonStyles.flex_center,
    },
    detailsContainer: {
      width: 375,
      maxWidth: '90%',
      overflow: 'auto',
      ...CommonStyles.br_16,
    },
  });

export default makeStyles;
